export default __webpack_public_path__ + "static/media/Shopping.bd2a65b9.png";